import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog'
import { useLanguage } from '@/contexts/LanguageContext'
import { OrganizationForm } from './OrganizationForm'

interface NewOrganizationDialogProps {
  open: boolean
  onOpenChange: (open: boolean) => void
  /** Called after org is successfully created */
  onCreated?: () => void
}

/**
 * Dialog component for creating a new organization with required billing country and optional default region
 */
export function NewOrganizationDialog({
  open,
  onOpenChange,
  onCreated,
}: NewOrganizationDialogProps) {
  const { t } = useLanguage();

  /**
   * Handle successful org creation
   */
  const handleSuccess = () => {
    onOpenChange(false);
    onCreated?.();
  }

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-[425px]">
        <DialogHeader>
          <DialogTitle>{t.dialogs.newOrganization.title}</DialogTitle>
          <DialogDescription>{t.dialogs.newOrganization.description}</DialogDescription>
        </DialogHeader>
        <OrganizationForm
          onSuccess={handleSuccess}
          onCancel={() => { onOpenChange(false); }}
        />
      </DialogContent>
    </Dialog>
  )
}
